import { ApiErrorCode } from "esa-core";
import { HttpError } from "esa-hooks";

const IP_RESTRICTION_ERROR_CODES: ApiErrorCode[] = [
  "ValidateAccess::ValidateIp::NotApplicableIpList",
  "ValidateIp::NotApplicableIpList",
];

// esa-api が IP アドレス制限でリクエストを拒否したかを判定する。
// フロントの制限判定は login_context のスナップショットに基づくため、
// このエラーは判定が古くなっているシグナルになる
export const isIpRestrictionError = (error: unknown): boolean =>
  error instanceof HttpError &&
  error.status === 403 &&
  IP_RESTRICTION_ERROR_CODES.includes(error.apiErrorCode);
